import { Box, Accordion, AccordionDetails, AccordionSummary, Paper, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { uiTokens } from "../../common/uiTokens";

const FAQ_SECTIONS = [
  {
    title: 'Začínáme',
    items: [
      {
        question: 'Jak vytvořím první plán?',
        answer:
          'Po dokončení onboardingu se ti v Přehledu zobrazí osobní cíle a doporučená jídla na den. Pokud chceš upravit výchozí hodnoty, otevři Nastavení (Bio a cíle) a změň váhu, cílovou váhu, aktivitu nebo preference.'
      },
      {
        question: 'Jak zaznamenám jídlo?',
        answer:
          'V Přehledu nebo přes doporučené karty použij „Sníst teď“, popř. v sekci Záznam vyber své jídlo a ulož ho. Po uložení se ihned upraví denní progres.'
      }
    ]
  },
  {
    title: 'Denní plán',
    items: [
      {
        question: 'Jak se počítají denní kalorie?',
        answer:
          'Denní kalorický cíl vychází z tvých zadaných údajů (např. váha, výška, věk, aktivita) a z cíle, který si nastavíš. Pak se zobrazuje, kolik zbývá na dnešní den podle už zaznamenaných jídel.'
      },
      {
        question: 'Co znamenají ukazatele progressu?',
        answer:
          'Progress ukazuje stav ke dni teď: kolik kalorií a makroživin jsi už snědl/a, jak blízko jsi cíli a kolik zbývá do limitů na zbytek dne.'
      },
      {
        question: 'Proč se doporučená jídla mění?',
        answer:
          'Doporučení se přepočítávají po každém záznamu, aby odpovídala aktuálnímu dennímu příjmu, zbývajícím kaloriím, preferencím, oblíbeným jídlům a aktuálnímu cíli.'
      }
    ]
  },
  {
    title: 'Doporučená jídla',
    items: [
      {
        question: 'Jak fungují upravené porce?',
        answer:
          'Uvidíš je ve formě „adjusted“ verze doporučeného jídla. Aplikace bere v úvahu, kolik už jsi dnes snědl/a, a upraví množství ingrediencí tak, aby dnešní doporučené kalorické a makro hodnoty seděly k plánu.'
      },
      {
        question: `Co znamená "Sníst teď"?`,
        answer:
          'Tlačítko „Sníst teď“ hned zapíše doporučené jídlo do dnešního deníku s upravenou porcí. Otevře to rychlý zápis bez dalšího vyplňování.'
      },
      {
        question: 'Co když jídlo upravím?',
        answer:
          'Když jídlo upravíš nebo přidáš vlastní porci, uloženej zápis bere tvoje nové hodnoty. Doporučení se budou dál přepočítávat podle aktuálního stavu.'
      }
    ]
  },
  {
    title: 'Jídla a potraviny',
    items: [
      {
        question: 'Jak vytvořím vlastní jídlo?',
        answer:
          'V sekci Jídla použij „+ Přidat jídlo“. Naplníš suroviny, název a čas jídla. Hotové jídlo pak můžeš hned zaznamenat nebo si ho uložit do oblíbených.'
      },
      {
        question: 'Jak přidám novou potravinu?',
        answer:
          'V sekci Jídla klikni na „+ Přidat potravinu“. Potvrď základní údaje (název, energie, makra) a potravinu pak najdeš ve výběru surovin.'
      }
    ]
  }
]

export function DietTips() {
  return (
    <Box sx={{ backgroundColor: uiTokens.colors.background, minHeight: '100vh', p: { xs: 2, md: 4 } }}>
      <Box sx={{ maxWidth: 1100, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h4" sx={{ color: uiTokens.colors.textPrimary, fontWeight: 700 }}>
          Nápověda
        </Typography>
        <Typography sx={{ color: uiTokens.colors.textSecondary }}>
          Krátké odpovědi na nejčastější otázky k plánování, doporučeným jídlům a záznamu jídel.
        </Typography>

        <Paper sx={{ borderRadius: 3, border: '1px solid #E6E1DB', p: 2, backgroundColor: '#FFFFFF', display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {FAQ_SECTIONS.map((section) => (
            <Accordion key={section.title} sx={{ borderRadius: 2, '&:before': { display: 'none' }, overflow: 'hidden', mb: 1.25, background: uiTokens.colors.surfaceMuted, border: '1px solid #E6E1DB' }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#7A4A2E' }} />}>
                <Typography sx={{ color: uiTokens.colors.textPrimary, fontWeight: 600 }}>{section.title}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ pt: 0 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  {section.items.map((item) => (
                    <Box key={item.question} sx={{ p: 1, border: '1px solid #EDE3D9', borderRadius: 2, background: '#FFFFFF' }}>
                      <Typography variant="subtitle1" sx={{ color: uiTokens.colors.textPrimary, fontWeight: 600 }}>
                        {item.question}
                      </Typography>
                      <Typography variant="body2" sx={{ color: uiTokens.colors.textSecondary, mt: 0.5 }}>
                        {item.answer}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </AccordionDetails>
            </Accordion>
          ))}
        </Paper>

        <Typography variant="body2" sx={{ color: uiTokens.colors.recommendationText, fontWeight: 600 }}>
          Doporučená jídla jsou průběžně přizpůsobována podle tvého dnešního stavu, cíle, preferencí a zbývajících kalorií a makroživin.
        </Typography>
      </Box>
    </Box>
  )
}
